import { useQuery } from 'react-query';
import { fetcher } from '../../client'
import { fetchTemplatesSaleHistoryList, fetchTemplatesSaleHistoryStats } from '../../actions/templates'

export function useTemplateSaleHistoryList(params = {}, options) {
  return useQuery(['sales-history', params], () => fetcher(fetchTemplatesSaleHistoryList(params)), options) 
}

export function useTemplateSaleHistoryStats(params = {}, options) {
  return useQuery(['sales-history-stats', params], () => fetcher(fetchTemplatesSaleHistoryStats(params)), options) 
}